import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {PROPERTY_FAQ_THINKING_MESSAGE} from "../../constants/property_faq_questions";

const PropertyDetailFaqLoadingIcon = () => (
    <svg className={loadingIconStyle} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <circle cx="14" cy="14" r="12" fill="var(--colors-primary)" />
        <path
            className={firstSparkleStyle}
            d="M13.9 0.5C14.35 5.25 16.16 7.06 20.9 7.5C16.16 7.95 14.35 9.76 13.9 14.5C13.46 9.76 11.65 7.95 6.9 7.5C11.65 7.06 13.46 5.25 13.9 0.5Z"
            fill="var(--colors-secondary)"
        />
        <path
            className={secondSparkleStyle}
            d="M5.4 9.2C5.7 12.18 6.82 13.3 9.8 13.6C6.82 13.9 5.7 15.02 5.4 18C5.1 15.02 3.98 13.9 1 13.6C3.98 13.3 5.1 12.18 5.4 9.2Z"
            fill="var(--colors-secondary)"
        />
        <path
            className={thirdSparkleStyle}
            d="M20.8 14.2C21.14 17.58 22.42 18.86 25.8 19.2C22.42 19.54 21.14 20.82 20.8 24.2C20.46 20.82 19.18 19.54 15.8 19.2C19.18 18.86 20.46 17.58 20.8 14.2Z"
            fill="var(--colors-secondary)"
        />
    </svg>
);

const PropertyDetailFaqTypingIndicator = () => (
    <div className={typingIndicatorStyle} aria-hidden>
        <span className={firstDotStyle} />
        <span className={secondDotStyle} />
        <span className={thirdDotStyle} />
    </div>
);

export const PropertyDetailFaqLoadingStatus = () => (
    <div className={loadingStatusStyle} role="status" aria-live="polite">
        <div className={desktopLoadingStyle}>
            <PropertyDetailFaqLoadingIcon />
            <Text variant="info_txt_1" as="span">
                {PROPERTY_FAQ_THINKING_MESSAGE}
            </Text>
        </div>

        <div className={mobileLoadingStyle}>
            <PropertyDetailFaqTypingIndicator />
            <span className={srOnlyStyle}>{PROPERTY_FAQ_THINKING_MESSAGE}</span>
        </div>
    </div>
);

const loadingStatusStyle = css({
    width: "100%"
});

const desktopLoadingStyle = css({
    display: "none",
    alignItems: "center",
    justifyContent: "center",
    gap: 1.5,
    minHeight: "4rem",

    md: {
        display: "flex"
    }
});

const mobileLoadingStyle = css({
    display: "flex",
    alignItems: "center",
    minHeight: "3.2rem",

    md: {
        display: "none"
    }
});

const loadingIconStyle = css({
    width: "2.8rem",
    height: "2.8rem",
    flexShrink: 0,
    overflow: "visible"
});

const sparkleStyle = {
    animationName: "propertyFaqSparkle",
    animationDuration: "1.2s",
    animationTimingFunction: "ease-in-out",
    animationIterationCount: "infinite",
    transformBox: "fill-box",
    transformOrigin: "center",
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        opacity: 1,
        transform: "none"
    }
} as const;

const firstSparkleStyle = css({
    ...sparkleStyle
});

const secondSparkleStyle = css({
    ...sparkleStyle,
    animationDelay: "0.18s"
});

const thirdSparkleStyle = css({
    ...sparkleStyle,
    animationDelay: "0.36s"
});

const typingIndicatorStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    px: 1
});

const dotStyle = {
    display: "block",
    width: "1.2rem",
    height: "1.2rem",
    borderRadius: "50%",
    backgroundColor: "var(--colors-background-200)",
    animationName: "propertyFaqTypingDot",
    animationDuration: "1.1s",
    animationTimingFunction: "ease-in-out",
    animationIterationCount: "infinite",
    transformOrigin: "center",
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        opacity: 1,
        transform: "none"
    }
} as const;

const firstDotStyle = css({
    ...dotStyle,
    animationDelay: "-0.36s"
});

const secondDotStyle = css({
    ...dotStyle,
    animationDelay: "-0.18s"
});

const thirdDotStyle = css({
    ...dotStyle
});

const srOnlyStyle = css({
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: 0
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {PROPERTY_FAQ_THINKING_MESSAGE} from "../../constants/property_faq_questions";

const PropertyDetailFaqLoadingIcon = () => (
    <svg className={loadingIconStyle} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <circle cx="14" cy="14" r="12" fill="var(--colors-primary)" />
        <path
            className={firstSparkleStyle}
            d="M13.9 0.5C14.35 5.25 16.16 7.06 20.9 7.5C16.16 7.95 14.35 9.76 13.9 14.5C13.46 9.76 11.65 7.95 6.9 7.5C11.65 7.06 13.46 5.25 13.9 0.5Z"
            fill="var(--colors-secondary)"
        />
        <path
            className={secondSparkleStyle}
            d="M5.4 9.2C5.7 12.18 6.82 13.3 9.8 13.6C6.82 13.9 5.7 15.02 5.4 18C5.1 15.02 3.98 13.9 1 13.6C3.98 13.3 5.1 12.18 5.4 9.2Z"
            fill="var(--colors-secondary)"
        />
        <path
            className={thirdSparkleStyle}
            d="M20.8 14.2C21.14 17.58 22.42 18.86 25.8 19.2C22.42 19.54 21.14 20.82 20.8 24.2C20.46 20.82 19.18 19.54 15.8 19.2C19.18 18.86 20.46 17.58 20.8 14.2Z"
            fill="var(--colors-secondary)"
        />
    </svg>
);

const PropertyDetailFaqTypingIndicator = () => (
    <div className={typingIndicatorStyle} aria-hidden>
        <span className={firstDotStyle} />
        <span className={secondDotStyle} />
        <span className={thirdDotStyle} />
    </div>
);

export const PropertyDetailFaqLoadingStatus = () => (
    <div className={loadingStatusStyle} role="status" aria-live="polite">
        <div className={desktopLoadingStyle}>
            <PropertyDetailFaqLoadingIcon />
            <Text variant="info_txt_1" as="span">
                {PROPERTY_FAQ_THINKING_MESSAGE}
            </Text>
        </div>

        <div className={mobileLoadingStyle}>
            <PropertyDetailFaqTypingIndicator />
            <span className={srOnlyStyle}>{PROPERTY_FAQ_THINKING_MESSAGE}</span>
        </div>
    </div>
);

const loadingStatusStyle = css({
    width: "100%"
});

const desktopLoadingStyle = css({
    display: "none",
    alignItems: "center",
    justifyContent: "center",
    gap: 1.5,
    minHeight: "4rem",

    md: {
        display: "flex"
    }
});

const mobileLoadingStyle = css({
    display: "flex",
    alignItems: "center",
    minHeight: "3.2rem",

    md: {
        display: "none"
    }
});

const loadingIconStyle = css({
    width: "2.8rem",
    height: "2.8rem",
    flexShrink: 0,
    overflow: "visible"
});

const sparkleStyle = {
    animationName: "propertyFaqSparkle",
    animationDuration: "1.2s",
    animationTimingFunction: "ease-in-out",
    animationIterationCount: "infinite",
    transformBox: "fill-box",
    transformOrigin: "center",
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        opacity: 1,
        transform: "none"
    }
} as const;

const firstSparkleStyle = css({
    ...sparkleStyle
});

const secondSparkleStyle = css({
    ...sparkleStyle,
    animationDelay: "0.18s"
});

const thirdSparkleStyle = css({
    ...sparkleStyle,
    animationDelay: "0.36s"
});

const typingIndicatorStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    px: 1
});

const dotStyle = {
    display: "block",
    width: "1.2rem",
    height: "1.2rem",
    borderRadius: "50%",
    backgroundColor: "var(--colors-background-200)",
    animationName: "propertyFaqTypingDot",
    animationDuration: "1.1s",
    animationTimingFunction: "ease-in-out",
    animationIterationCount: "infinite",
    transformOrigin: "center",
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        opacity: 1,
        transform: "none"
    }
} as const;

const firstDotStyle = css({
    ...dotStyle,
    animationDelay: "-0.36s"
});

const secondDotStyle = css({
    ...dotStyle,
    animationDelay: "-0.18s"
});

const thirdDotStyle = css({
    ...dotStyle
});

const srOnlyStyle = css({
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: 0
});
